import { Node, mergeAttributes } from '@tiptap/core';

export const StageDirection = Node.create({
  name: 'stageDirection',
  group: 'block',
  content: 'inline*',
  marks: 'bold italic underline',

  parseHTML() {
    return [{ tag: 'p[data-type="stage-direction"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'p',
      mergeAttributes(HTMLAttributes, {
        'data-type': 'stage-direction',
        class: 'play-stage-direction',
        spellcheck: 'true',
      }),
      0,
    ];
  },
});
